import {useMutation, useQueryClient} from "react-query";
import {useHistory, useParams} from "react-router-dom";
import Alert from "react-s-alert";
import {
  CreateSsoConfigurationRequest,
  SsoService,
} from "../../../services/SsoService";
import {buildResponseErrorMessage} from "../../../services/api/errorHelpers";

export const useCreateSsoConfiguration = () => {
  const queryClient = useQueryClient();
  const history = useHistory();
  const {organizationId} = useParams<{organizationId: string}>();

  return useMutation(
    (data: CreateSsoConfigurationRequest) =>
      SsoService.createConfiguration(organizationId, data),
    {
      onSuccess: () => {
        Alert.success("SSO configuration was successfully created.");
        queryClient.invalidateQueries(["ssoConfiguration"]);
        history.push(
          `/admin/organizations/${organizationId}/sso-configuration`,
        );
      },
      onError: async resp => {
        Alert.error(
          await buildResponseErrorMessage(
            resp,
            "Failed to create SSO configuration.",
          ),
        );
      },
    },
  );
};
